<template>
    <div class="o-page__inner"
        :class="{ '-embedded': embedded }"
        :data-component-name="$options.name"
    >
		<div class="-two-columns">
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title" v-if="!embedded">Contacts clients</h1>
                        <h2 class="o-form__title q-mt-lg q-mb-md" v-else>Contacts</h2>
                        <Listbox
                            :embedded="embedded"
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @set-search-text="setSearchText('searchContactText', $event)"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                            :isSmall="isSmall"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3" :class="(embedded)? 'q-mt-md':''">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button" v-if="!embedded">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>

                            <!-- <h1 class="o-form__title" v-if="!embedded">Contacts clients</h1> -->
                            <input v-if="form.id" type="hidden" v-model="form.id" />
                            <div class="o-form__item">
                                <Input
                                    v-model="form.name"
                                    ref="name"
                                    placeholder="Nom du contact"
                                    label="Nom du contact"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.email"
                                    placeholder="Courriel"
                                    label="Courriel"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item full-width q-mb-lg" v-if="form && form.id>0">
                                <Input
                                    id="userProfileTitle"
                                    v-model="form.title"
                                    placeholder="ex. Chargé de projet"
                                    label="Titre"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.primary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone principal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.secondary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone secondaire"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.fax"
                                    placeholder="(111) 111-1111"
                                    label="Télécopieur"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item q-mb-lg">
                                <Input
                                    v-model="form.website"
                                    placeholder="https://lesite.com"
                                    label="Site Internet"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.street"
                                    placeholder="Rue"
                                    label="Adresse"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.town"
                                    placeholder="Ville"
                                    label="Ville"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.state"
                                    placeholder="Ex. Qc"
                                    label="Province"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.country"
                                    placeholder="Pays"
                                    label="Pays"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item q-mb-lg">
                                <Input
                                    v-model="form.zipcode"
                                    placeholder="Ex. A1A 1A1"
                                    label="Code postal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item" v-if="!$apollo.loading && !selectedParent_id">
                                <Select
                                    :options="customers.customers.data"
                                    placeholder="Choisir une client"
                                    label="Client"
                                    v-model="form.customer"
                                    :clearable="false"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item full-width">
                                <Input
                                    type="textarea"
                                    v-model="form.note"
                                    placeholder="Note"
                                    label="Note"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <input type="hidden" v-if="selectedParent_id" v-model="form.customer_id">
                            <div class="o-form__item -button -multiple" v-if="embedded">
                                <button type="button" class="o-button -md" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button class="o-button -md" :loading="$apollo.loading" color="primary" v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon class="o-ico" name="save" />
                                </button>
                                <button class="o-button -md" :loading="$apollo.loading" color="primary" v-if="!form.id">
                                    Ajouter
                                    <q-icon class="o-ico" name="save" />
                                </button>
                            </div>

                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { CUSTOMERSLIST, CONTACTSFULL, CONTACTSSEARCHFULL/*, LOCATIONS*/ } from '@/graphql/customer/queries'
    import { UPSERTCONTACT, DELETECONTACT, RESTORECONTACT } from '@/graphql/customer/mutations'
    import { removeNULL } from '@/js/utilities'

    export default {
        name: 'CustomersContacts',
        props: {
            parent_id: {
                default: null
            },
            embedded: {
                type: Boolean,
                default: false
            },
            isSmall: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchableQL: 'Rechercher / filtrer'
                },
                searchContactText: null,
                form: { customer_id: null },
                newItem: {
                    id: 0,
                    name: null,
                    email: null,
                    primary_phone: null,
                    secondary_phone: null,
                    fax: null,
                    street: null,
                    town: null,
                    state: null,
                    country: null,
                    zipcode: null,
                    website: null,
                    customer_id: null
                },
                showDeleted: false,
                perPage: 100,
            }
        },
        apollo: {
            contacts: {
                query: CONTACTSFULL,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(contacts) {
                    this.listbox.listItems = Object.assign([], contacts.contacts.data)
                    return contacts;
                },
                variables() {
                    let variables = { trashed: this.trashed, first: this.perPage };
                    if (this.selectedParent_id !== null) {
                        variables.customer_id = this.selectedParent_id;
                    }
                    return variables;
                }
            },
            customers: {
                query: CUSTOMERSLIST,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(customers) {
                    // this.listbox.listItems = Object.assign([], customers.customers.data)
                    return customers;
                },
                variables() {
                    return {
                        // searchText: null,
                        trashed: "WITH",
                        first: this.perPage
                    }
                }
            },
        },
        mounted: async function(){
            if(this.parent_id) this.listbox.searchableQL=false;
            this.setNewItem();
        },
        computed: {
            selectedParent_id () {
                this.setNewItem();
                return this.parent_id
            },
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.newItem.customer_id=this.parent_id;
                this.setSelected(this.newItem);

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            setSearchText(prop, searchText){
                this.setSelected(this.newItem);
                if(searchText && searchText.length>1) searchText=searchText.trim().split(" ").join("* ")+"*";
                this.fetchSearchText(searchText);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETECONTACT,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.contacts) this.$apollo.queries.contacts.refetch()
                        this.setSelected(null)
                    }
                })
            },
            async fetchSearchText(searchText){
                if(searchText && searchText!=""){
                    if(this.$apollo.queries.contactsSearch){
                        this.$apollo.queries.contactsSearch.options.variables.searchText=searchText;
                        this.$apollo.queries.contactsSearch.refresh();
                    } else {

                        let search = searchText.trim().split(" ").join("* ") + "*";
                        search = search.replace(/\*\*/g, '*');

                        this.$apollo.addSmartQuery('contactsSearch', {
                            query: CONTACTSSEARCHFULL,
                            fetchPolicy: 'network-only',
                            error(error){
                                if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                            },
                            variables: {
                                searchText: search,
                            },
                            update(contactsSearch) {
                                this.listbox.listItems = Object.assign([], contactsSearch.contactsSearch.data)
                                return contactsSearch;
                            },

                        })
                    }
                }else{
                    this.$apollo.queries.contacts.refresh()
                }
            },
            saveItem(form) {
                form=removeNULL(form);
                if(form.customer) form.customer_id=form.customer.id
                this.$apollo.mutate({
                    mutation: UPSERTCONTACT,
                    variables: { ...form },
                    update: (store, { data: { upsertCustomerContact } }) => {
                        if(!form.id){
                            let myVariables = { trashed: this.trashed, first: this.perPage }
                            if(this.selectedParent_id) myVariables.customer_id = this.selectedParent_id
                            const data = store.readQuery({
                                query: CONTACTSFULL,
                                variables: myVariables
                            })
                            data.contacts.data.push(upsertCustomerContact);

                            store.writeQuery({
                                query: CONTACTSFULL,
                                data,
                                // variables: myVariables
                            })
                        }
                        this.setSelected(upsertCustomerContact);
                    }
                }).then((/*data*/) => {
                    this.$q.notify({type: 'positive', message: "Contact : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORECONTACT,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { contact } }) => {
                        if (!form.id) {
                            const data = store.readQuery({ query: CONTACTSFULL })
                            data.contacts.data.push(contact);
                            store.writeQuery({
                                query: CONTACTSFULL,
                                data,
                            })
                        }
                        this.setSelected(contact);
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Ressource : " + form.name, caption: "Informations sauvegardées" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
